import axios from 'axios'
import {ResponseObject} from '../../../models'
import {
  AssigmentModel,
  CellphoneAssignModel,
  CreatePhoneAssigmentModel,
  CreateScheduleAssigmentModel,
  LayoutModelDto,
  ScheduleAssignModel,
  ScheduleAssignmentFilter,
  SearchAssigmentModel,
} from '../model/assigment.model'
import {ResponseObjectPaginated} from '../model/response.model'

const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export async function createAssigment(data: AssigmentModel) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/assignment/create`, data)
}

export async function createPhoneAssigment(data: CreatePhoneAssigmentModel) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/assignment/phone`, data)
}

export async function createScheduleAssigment(data: CreateScheduleAssigmentModel) {
  return await axios.post<ResponseObject<any>>(`${BASEURL}/assignment/scheduling`, data)
}

export async function getCellphoneAssignment(dto: any) {
  return axios.post<ResponseObjectPaginated<CellphoneAssignModel[]>>(
    `${BASEURL}/assignment/getListPhone`,
    dto,
  )
}

export async function getScheduleAssignment(dto: any) {
  return axios.post<ResponseObjectPaginated<ScheduleAssignModel[]>>(
    `${BASEURL}/assignment/getListSchedulingAssignment`,
    dto,
  )
}

export async function getListSchedulingFilter(dto: ScheduleAssignmentFilter) {
  return axios.post<ResponseObjectPaginated<ScheduleAssignModel[]>>(
    `${BASEURL}/assignment/getListSchedulingFilter`,
    dto,
  )
}

export async function getListScheduling(dto: ScheduleAssignmentFilter) {
  return axios.post<ResponseObjectPaginated<ScheduleAssignModel[]>>(
    `${BASEURL}/assignment/getListScheduling`,
    dto,
  )
}

export async function drawLayout(data: SearchAssigmentModel) {
  return await axios.post<ResponseObject<LayoutModelDto[]>>(
    // `https://sode-khipu-back.azurewebsites.net/limpieza/backend/api/assignment/getList`,
    `${BASEURL}/assignment/getLayout`,
    data,
  )
}
